import type { JSX } from 'react';
import { BUILD_INFO } from '../../build-info.js';

export interface BuildBadgeProps {
  className?: string;
}

export function BuildBadge({ className = '' }: BuildBadgeProps): JSX.Element {
  return (
    <span
      data-testid="build-badge"
      title={`Wersja: ${BUILD_INFO.tag} (${BUILD_INFO.commit}) · Zbudowano: ${BUILD_INFO.builtAt}`}
      className={`inline-flex items-center rounded border border-cyan-800/60 bg-cyan-950/40 px-1.5 py-0.5 text-[10px] font-mono font-medium text-cyan-300 ${className}`}
    >
      {BUILD_INFO.tag} ({BUILD_INFO.commit})
    </span>
  );
}
